import { frontendURL } from '../../../helper/URLHelper';
import LiveIndex from './pages/LiveIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/painel/ao-vivo'),
    name: 'live_conversations_index',
    component: LiveIndex,
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
  },
];
